export default __webpack_public_path__ + "static/media/fondo-encontranos-home.a85c1082.png";